module.exports = __webpack_public_path__ + "static/media/191CS108.2abffa37.JPG";